export enum AnalysisSuggestionStatus {
  waiting = 'waiting',
  sending = 'sending',
  sent = 'sent',
}
